import $ from 'jquery';

window.dismissAchievement = (type, sport) => {
    $.ajax({
        'url': '/achievements/update/' + type + '/' + sport,
        'method': 'get',
        'success': function (resp) {
            console.log("Achievement:", resp);
        }
    });
};
